// extracted by mini-css-extract-plugin
module.exports = {"story_newday":"StoryNewDay_story_newday__IB5FB","story_mobile_newday":"StoryNewDay_story_mobile_newday__CgYCc"};